// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"6a02b88a","117":"d54c0858","243":"36ab128d","632":"0a15ab25","808":"c0f53ef0"}[chunkId] + ".chunk.css";
};